/**
 * Normalize any UI / quick-reply payload to a single trimmed string for POST body.
 * @param {unknown} input
 * @returns {string}
 */
export function normalizeOutgoingChatMessage(input) {
  if (input === null || input === undefined) return "";
  if (typeof input === "number" && Number.isFinite(input)) {
    return String(input).trim();
  }
  if (typeof input === "string") {
    return input.trim();
  }
  if (typeof input === "object") {
    const o = /** @type {Record<string, unknown>} */ (input);
    const cand = o.message ?? o.text ?? o.value ?? o.label ?? o.body;
    if (cand === null || cand === undefined) return "";
    return normalizeOutgoingChatMessage(cand);
  }
  return String(input).trim();
}
